import React, { Component } from "react";
import { make_request } from "../../Utils/Utils";

class LevelFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: this.props.rating,
    };
  }

  handle_change = (event) => {
    this.setState({
      rating: event.target.value,
    });
    make_request({
      path: 'rating',
      method: "POST",
      content: "JSON",
      body: {
        id: this.props.id,
        rating: event.target.value,
      },
    });

  };
 
  async componentDidMount() {
  }


  render() {
    return (
      <div className="col">
        <div className="rating_box">
          <img src={this.props.image} alt="" />
          <h5> Level #{this.props.number} </h5>
          <p> {this.props.notes} </p>
          <div className="rate" value={this.state.rating}>
            <input
              type="radio"
              id={`star${this.props.number}5`}
              onChange={this.handle_change}
              name={`level_${this.props.id}`}
              checked={"5" === this.state.rating}
              value="5"
            />
            <label htmlFor={`star${this.props.number}5`} title="5 star">
              5 stars
            </label>
            <input
              type="radio"
              id={`star${this.props.number}4`}
              onChange={this.handle_change}
              name={`level_${this.props.id}`}
              checked={"4" === this.state.rating}
              value="4"
            />
            <label htmlFor={`star${this.props.number}4`} title="4 star">
              4 stars
            </label>
            <input
              type="radio"
              id={`star${this.props.number}3`}
              onChange={this.handle_change}
              name={`level_${this.props.id}`}
              checked={"3" === this.state.rating}
              value="3"
            />
            <label htmlFor={`star${this.props.number}3`} title="3 star">
              3 stars
            </label>
            <input
              type="radio"
              id={`star${this.props.number}2`}
              onChange={this.handle_change}
              name={`level_${this.props.id}`}
              checked={"2" === this.state.rating}
              value="2"
            />
            <label htmlFor={`star${this.props.number}2`} title="2 star">
              2 stars
            </label>
            <input
              type="radio"
              id={`star${this.props.number}1`}
              onChange={this.handle_change}
              name={`level_${this.props.id}`}
              checked={"1" === this.state.rating}
              value="1"
            />
            <label htmlFor={`star${this.props.number}1`} title="1 star">
              1 star
            </label>
          </div>
        </div>
      </div>
    );
  }
}
export default LevelFeedback;
